import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { CoreModule } from '../core.module';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
	providedIn: CoreModule,
})
export class CanDeactivateGuard {
	canDeactivate(component: CanComponentDeactivate) {
		return component.canDeactivate ? component.canDeactivate() : true;
	}
}
